<template>
	<div class="DeepSeekChat">
		<div class="app-container chat-container" :class="{fullscreen:isFullScreen,initChat: !visiable}"
			id="main-custom" ref="chatBox">
			<div class="header-action">
				<div class="fullscreen" @click="fullscreen"></div>
				<div class="close" @click="close"></div>
			</div>
			<div class="overflow-container" ref="scrollArea">
				<div class="hello">
					<!-- <div class="logo"></div> -->
					<div class="left">
						<div class="hello-text"></div>
						<div class="text">我擅长解答题目，快来试试吧！</div>
					</div>

				</div>
				<div class="hot-container" v-if="hotLists && hotLists.length>0">
					<div class="title">热门知识点</div>
					<div class="labels">
						<div class="label" :class="{labelCheck: checkIndex == index}" v-for="(item,index) in hotLists"
							:key="index" @click="checkHots(item,index)">
							<div class="star"></div>
							<div class="item">{{ item }}</div>
						</div>
					</div>
				</div>
				<!-- 主聊天区域 -->
				<div class="chat-main">
					<div class="chat-container-wrapper">
						<!-- 消息列表 -->
						<div class="chat-messages">
							<div v-for="(message, index) in messages" :key="index">
								<div :class="['message', message.role === 'user' ? 'message-user' : 'message-ai']">
									<div class="message-avatar">
										<img :src="message.role === 'user' ? headImg  : require('@/assets/images/ai/robot-head.png')"
											:alt="message.role === 'user' ? userName : 'AI'" />
									</div>

									<div class="message-content">
										<div v-if="message.role === 'user' " class="message-time">
											{{ $util.parseTime(message.timestamp) }}
										</div>
										<div v-if="message.role === 'user' " class="message-text">
											<img v-if="message.content.indexOf('file.wenms.com')>-1"
												:src="message.content" @click="onPreview(message.content)">
											<span v-else> {{ message.content }}</span>
										</div>
										<div class="message-text think"
											v-else-if="isThinking && index == messages.length-1">
											<span>小问 正在思考...</span>
											<el-icon class="el-icon-loading" />
										</div>
										<div v-else class="message-text" v-html="$markdownEscape(message.content) ">
										</div>
										<!-- <div class="message-time">{{ $util.parseTime(message.timestamp) }}</div> -->
									</div>
								</div>
								<!-- 推荐 -->
								<div class="recommend-container">
									<div class="label" :class="{labelCheck: message.checkRecommendIndex == rIndex}"
										v-for="(recommend,rIndex) in message.recommendLists" :key="rIndex"
										@click="checkRecommend(message,rIndex)">
										<div class="item">{{ recommend }}</div>
										<div class="next"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 输入区域 -->
			<div class="chat-input-wrapper">
				<div class="chat-input">
					<div class="input-wrapper">
						<el-input v-model="inputMessage" type="textarea" placeholder="请输入您的问题..." resize="none"
							@keyup.enter.native="sendMessage" />
						<div class="send-btn" @click="sendMessage">
							<!-- <el-upload class="upload-demo" action="" :on-change="handleImageChange"
              :before-upload="beforeUpload" :on-success="uploadSuccess" :on-error="uploadError"
              :show-file-list="false" listType="picture-card" accept="image/jpeg, image/jpg, image/png">
              <div class="headImg"
                :style="`background-image: url(${obj.headImg ? obj.headImg : $store.state.userInfo.role == 1 ? require('@/static/student.png') : require('@/static/teacher.png')})`">
              </div>
              <div class="iconfont icon-shangchuan"></div>
            </el-upload> -->
							<el-upload class="send-upload" :show-file-list="false"
								:action="`${$rootUrl}/api/system/uploadFile/100`" :headers="headers"
								:on-success="uploadSuccess" accept="image/jpeg, image/jpg, image/png">
								<div class="send-upload"></div>
							</el-upload>
							<div :class="inputMessage || isLoading ?'send-message send-message-active':'send-message'">
								<!-- <div class="message-icon"></div> -->
								<el-icon class="message-icon"
									:class="isLoading? 'el-icon-video-pause':'el-icon-s-promotion'" />
							</div>
						</div>
						<!-- <el-button
              type="primary"
              @click="sendMessage"
              :class="isLoading? 'isLoading':''"
            >
              {{isLoading?'停止':'发送'}}
              <el-icon :class="isLoading? 'el-icon-video-pause':'el-icon-s-promotion'"/>
            </el-button> -->
					</div>
				</div>
			</div>
		</div>
		<div class="logo-xiaowen" @click="openChat()" v-show="showIcon"></div>
		<el-tooltip popper-class="custom-tooltip" content="Hi,我是你的Ai小问老师" placement="left" effect="light">
			<div class="logo-container" @click="openChat()" v-show="showIcon">
				<div class="xiaowen">小问老师</div>
			</div>
		</el-tooltip>
		<el-dialog title="图片预览" :visible.sync="dialogTableVisible">
			<div class="modal-content">
				<el-image :src="previewImageSrc" fit="contain"></el-image>
			</div>
		</el-dialog>
	</div>

</template>

<script>
	import {
		findDocumentStorageByPg
	} from '@/api/ai/chatBox.js'

	export default {
		name: 'DeepSeekChat',
		props: {
			// productId: {require : true}
		},
		data() {
			return {
				userName: '',
				headImg: '',
				chatHistory: [{
						title: '如何学习机器学习？',
						time: '昨天 15:30'
					},
					{
						title: 'Python编程技巧',
						time: '前天 09:45'
					}
				],
				messages: [
					// {
					//   content: '同学们好，我是小问老师。今天我们来一起学习一下直线运动的相关知识。\n\n直线运动是物体运动的一种基本形式，它指的是物体在一条直线上运动的机械运动。我们通常会从以下几个方面来研究直线运动：\n\n1. **位移（Displacement）**：位移是描述物体位置变化的物理量，它是从初始位置指向末位置的有向线段。位移是矢量，其单位是米（m）。\n\n2. **速度（Velocity）**：\n   - 平均速度：在某段时间内，物体的位移与所用时间的比值，公式为 $\\bar{v} = \\frac{\\Delta x}{\\Delta t}$。\n   - 瞬时速度：物体在某一时刻或某一位置的速度。\n\n3. **加速度（Acceleration）**：加速度是描述速度变化快慢的物理量，定义为速度变化量与发生这一变化所用时间的比值，公式为 $a = \\frac{\\Delta v}{\\Delta t}$。\n\n4. **匀变速直线运动**：加速度恒定的直线运动，其速度随时间均匀变化。常用的运动学公式包括：\n   - $v = v_0 + at$\n   - $x = v_0t + \\frac{1}{2}at^2$\n   - $v^2 = v_0^2 + 2ax$\n\n5. **自由落体运动**：一种特殊的匀变速直线运动，物体仅受重力作用，加速度为重力加速度 $g$（约为 $9.8 \\, \\text{m/s}^2$）。\n\n6. **图像分析**：\n   - 位移-时间图像（x-t图）：斜率表示速度。\n   - 速度-时间图像（v-t图）：斜率表示加速度，面积表示位移。\n\n### 应用场景举例：\n1. **汽车刹车问题**：已知汽车的初速度和刹车时的加速度，可以计算刹车距离和刹车时间。\n2. **自由落体实验**：通过测量物体下落的时间，可以计算物体下落的高度。\n3. **匀速直线运动**：如火车在平直轨道上的行驶。\n\n### 例题推荐：\n**例题1**：一辆汽车以 $20 \\, \\text{m/s}$ 的速度行驶，紧急刹车时的加速度大小为 $5 \\, \\text{m/s}^2$，求刹车后 $3 \\, \\text{s}$ 内的位移。\n\n**解题思路**：\n- 已知初速度 $v_0 = 20 \\, \\text{m/s}$，加速度 $a = -5 \\, \\text{m/s}^2$（负号表示减速），时间 $t = 3 \\, \\text{s}$。\n- 使用公式 $x = v_0t + \\frac{1}{2}at^2$ 计算位移。\n\n$$\nx = 20 \\times 3 + \\frac{1}{2} \\times (-5) \\times 3^2 = 60 - 22.5 = 37.5 \\, \\text{m}\n$$\n\n**答案**：刹车后 $3 \\, \\text{s}$ 内的位移为 $37.5 \\, \\text{m}$。\n\n如果你对某个知识点或例题还有疑问，欢迎继续提问！',
					//   sender: 'ai',
					//   timestamp: Date.now()
					// }
				],
				inputMessage: '',
				selectedModel: 'deepseek-1',
				chatStyle: 'professional',
				currentChatIndex: 0,
				isLoading: false,
				eventSource: null,
				intervalId: null, // 打字机效果的定时器
				mathmlInterval: null,
				visiable: false,
				taskId: null,
				userId: null,
				isThinking: false,
				hotLists: [],
				isFullScreen: false,
				checkIndex: null,
				msgId: null,
				showIcon: false,
				recommendLists: [],
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem("token")
				},
				dialogTableVisible: false,
				previewImageSrc: '',
				isEnd: false,
                productId: null
			}
		},
		watch: {
			$route(route) {
				// 定义需要隐藏的路径
				const hidePaths = [
					'/student/homework/homeworkAnswer',
					'/student/exam/examAnswer',
					'/'
				];

				// 检查当前路径是否需要隐藏（完全相等）
				const shouldHide = hidePaths.includes(route.path);

				if (shouldHide) {
					// 在指定路径下隐藏图标和聊天窗口
					this.close();
					this.showIcon = false;
					this.visiable = false;
				} else {
					// 其他所有页面都显示图标
					this.showIcon = true;
				}
			}
		},
		mounted() {
			this.userId = JSON.parse(localStorage.getItem("vuex")).userInfo.userId
			this.userName = JSON.parse(localStorage.getItem("vuex")).userInfo.nickName
			this.headImg = JSON.parse(localStorage.getItem("vuex")).userInfo.headImg || require('@/static/teacher.png')
		},
		methods: {
			onPreview(url) {
				this.previewImageSrc = url;
				this.dialogTableVisible = true
			},
			uploadSuccess(res, file) {
				this.inputMessage = res.data.url
				this.sendMessage(true)
			},
			close() {
				this.stopMessage()
				this.isFullScreen = false
				this.visiable = false
			},
			openChat(message) {
                this.productId = this.$route.query.productId || null
				// 1.小问关闭状态
				// 2.小问正常状态
				// 3.小问问答状态
				if (!this.visiable) {
					this.checkIndex = null
					this.msgId = null
					this.visiable = true
					this.messages = []
					this.getHots()
					if (message) {
						this.inputMessage = `帮我生成${message}相关知识`
					} else {
						this.inputMessage = ''
					}
				} else if (!this.isLoading) {
					if (message) {
						this.inputMessage = `帮我生成${message}相关知识`

					} else {
						this.inputMessage = ''
					}
				} else {
					this.$message.info('小问思考中...')
				}

			},
			checkHots(item, index) {
				this.checkIndex = index
				this.inputMessage = `帮我生成${item}相关知识`
				this.sendMessage()
			},
			checkRecommend(item, index) {
				this.$set(item, "checkRecommendIndex", index)
				this.inputMessage = `${item.recommendLists[index]}`
				this.sendMessage()
			},
			getHots() {
				this.hotLists = []
				this.$request.get(`course/getCourseHotKnowledgeList/${this.productId}`).then(res => {
					this.hotLists = res.data
				})
			},
			fullscreen() {
				this.isFullScreen = !this.isFullScreen
			},
			// 开启新会话
			startNewChat() {

			},
			// 停止回复
			stopMessage() {
				if (this.visiable) {
					if (this.isLoading) {
						this.terminateSSE()
						this.isLoading = false
						this.clearIntervalId('intervalId')
						// if (this.taskId) {
						// 	this.$request.get(`aIApi/stop?taskId=${this.taskId}&userId=${this.userId}`).then(res => {
						// 		this.isLoading = false
						// 		this.clearIntervalId('intervalId')
						// 	})
						// } else {
						// 	this.isLoading = false
						// 	this.clearIntervalId('intervalId')
						// }
					}
				}

			},
			//获取推荐
			getRecomand(assistantMsg) {
				//图片不获取推荐
				if (this.messages[this.messages.length - 2].content.indexOf("file.wenms.com") > -1) {
					return
				}
				assistantMsg.recommendLists = []
				this.$request.get(`aIApi/suggestions?prompt=${this.messages[this.messages.length-2].content}`).then(
					res => {
						if (res.succeeded) {
							this.$set(assistantMsg, 'recommendLists', res.data)
							this.$nextTick(() => this.scrollToBottom());
						}
					})
				this.isLoading = false
			},
			// 发送消息
			async sendMessage(isImage) {
				if (this.isLoading) {
					this.stopMessage()
				}
				if (!this.inputMessage.trim() || this.isLoading) return;
				// 添加用户消息
				this.messages.push({
					role: 'user',
					content: this.inputMessage,
					timestamp: Date.now()
				});
				this.inputMessage = '';
				this.isLoading = true;
				this.isThinking = true;
				this.isEnd = false;
				let index = 0 // 第几条流返回
				let temp = '' // 返回临时数据
				let assistantMsg = {
					role: 'assistant',
					content: '',
					timestamp: Date.now(),
					recommendLists: [],
					checkRecommendIndex: null
				};
				this.messages.push(assistantMsg);
				this.$nextTick(() => this.scrollToBottom());

				try {
					// this.simulateAIResponse()
					// 创建 SSE 连接（携带 Token）
					this.eventSource = await findDocumentStorageByPg(
						this.messages[this.messages.length - 2].content, isImage, this.productId
					);
					// 初始化助手消息

					// 流式数据处理器
					this.eventSource.onmessage = (event) => {
						if (event.data) {
							let res = JSON.parse(event.data).output
							// if(res.TaskId){
							// this.taskId = JSON.parse(event.data).TaskId
							// }
							// if(res.MessageId && res.MessageId != this.msgId){
							// this.msgId = res.MessageId
							// }
							let finishReason = res.finish_reason
							res = res.text
							if (finishReason != 'stop') {
								if (!temp) {
									temp = res
									if (!this.intervalId) {
										this.isThinking = false
										this.intervalId = setInterval(() => {
											if (index < temp.length) {
												let content = assistantMsg.content + temp[index];
												assistantMsg.content = content.replace(
													/\$\s*([^$]*?)\s*\$/g, (_, content) => {
														return `$${content}$`;
													});
												index++;
												this.$nextTick(() => this.scrollToBottom());
											} else if (this.isEnd) {
												this.clearIntervalId('intervalId')
												this.getRecomand(assistantMsg)
											}
										}, 10); // 每100毫秒显示一个字符
									}
								} else {
									temp += res
								}
							} else if (finishReason == 'stop') {
								// 错误处理
								this.isEnd = true
								this.eventSource.onerror = (e) => {
									console.error('SSE  Error:', e);
									this.eventSource.close();
								};
							}
						}
					}
				} catch (error) {
					console.error('API  Error:', error);
					this.isLoading = false;
				}
			},
			terminateSSE() {
				this.isThinking = false
				if (!this.messages[this.messages.length - 1].content) {
					this.messages.splice(-1, 1);
				}
				if (this.eventSource) {
					this.eventSource.close(); // 关闭连接
					console.log('SSE 连接已关闭');
					// 清理事件监听器
					this.eventSource.onmessage = null;
					this.eventSource.onerror = null;
				}
			},
			clearIntervalId(filed) {
				if (this[filed]) {
					clearInterval(this[filed]);
					this[filed] = null
				}
			},
			switchChat(index) {

			},
			scrollToBottom() {
				const container = this.$refs.scrollArea;
				if (container) {
					container.scrollTop = container.scrollHeight;
				}
			}
		},
		beforeUnmount() {
			this.clearIntervalId('intervalId')
			if (this.eventSource) this.eventSource.close();
		}
	};
</script>

<style scoped lang="scss">
	::v-deep .el-textarea__inner {
		height: 100px;
	}

	.modal-content {
		margin: 10px auto;
		padding: 20px;
		width: 90%;
		max-width: calc(60vw - 60px);
		text-align: center;
		background-color: white;
		border-radius: 8px;

		::v-deep .el-image__inner {
			width: 100%;
			height: auto;
			max-width: 100%;
			max-height: 60vh;
			/* 设置最大高度为视口高度的80% */
			object-fit: contain;
			/* 确保图片按比例缩放并适应容器 */
		}
	}

	.logo {
		width: 50px;
		height: 50px;
		background: url('@/assets/images/ai/robot-head.png');
		background-repeat: no-repeat;
		background-size: cover;
		transform: scaleX(-1);
		margin-top: -17px;
		width: 74px;
		height: 63px;
	}

	.DeepSeekChat {
		position: relative;
	}

	.logo-container {
		transform: scale(0.8);
		cursor: pointer;

		.xiaowen {
			font-size: 12px;
			color: #8C8C8C;
			margin-top: 2px;
		}

		&:hover .xiaowen {
			color: #0D68FF;
		}
	}

	.logo-xiaowen {
		transition: none;
		width: 100px;
		height: 120px;
		background: url('@/static/AI.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: bottom center;
		position: absolute;
		bottom: 100%;
		left: 50%;
		transform: translateX(-50%);
		margin-bottom: 5px;
		cursor: pointer;
		z-index: 1000;

		// .robot{
		// 	background: url('@/assets/images/pastyearpaper/robot.png');
		// 	background-repeat: no-repeat;
		// 	background-size: cover;
		// 	width: 70px;
		// 	height: 140px;
		// 	position: absolute;
		// 	z-index: 3;
		// 	animation: floatRobotTop 3.5s ease-in-out infinite;
		// }
		// .robot-left{
		// 	background: url('@/assets/images/pastyearpaper/robot-left.png');
		// 	background-repeat: no-repeat;
		// 	background-size: cover;
		// 	width: 40px;
		// 	height: 67px;
		// 	top: 65px;
		// 	left: -40px;
		// 	position: absolute;
		// 	animation: floatRobotLeft 4s ease-in-out infinite;
		// 	z-index: 4;
		// }
		// .robot-right{
		// 	background: url('@/assets/images/pastyearpaper/robot-right.png');
		// 	background-repeat: no-repeat;
		// 	background-size: cover;
		// 	width: 40px;
		// 	height: 67px;
		// 	top: 50px;
		// 	left: 70px;
		// 	position: absolute;
		// 	animation: floatRobotRight 4s ease-in-out infinite;
		// 	z-index: 4;
		// }
		// .robot-bottom{
		// 	background: url('@/assets/images/pastyearpaper/robot-bottom.png');
		// 	background-repeat: no-repeat;
		// 	background-size: cover;
		// 	width: 170px;
		// 	height: 100px;
		// 	bottom: 0;
		// 	left: -57px;
		// 	position: absolute;
		// 	animation: floatRobotBot 4s ease-in-out infinite;
		// }
	}

	// .logo-xiaowen:hover {
	// 	animation: elasticScale 1s ease-in-out infinite;
	// }

	@keyframes elasticScale {
		0% {
			transform: scale(1);
			/* 初始状态 */
		}

		50% {
			transform: scale(1.2);
			/* 中间状态：放大到 1.3 倍 */
		}

		100% {
			transform: scale(1);
			/* 最终状态：放大到 1.1 倍 */
		}
	}

	@keyframes jumpOut {
		0% {
			transform: translateX(100%) scale(0);
			/* 初始状态：从下方进入，缩小 */
			opacity: 0;
			/* 初始透明度为 0 */
			box-shadow: 0 0 0 rgba(0, 0, 0, 0);
			/* 无阴影 */
		}

		50% {
			transform: translateX(-10px) scale(1.2);
			/* 中间状态：向上跳起，稍微放大 */
			opacity: 1;
			/* 完全可见 */
			box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
			/* 添加阴影 */
		}

		100% {
			transform: translateY(0) scale(1);
			/* 最终状态：回到原位，恢复正常大小 */
			box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
			/* 阴影减弱 */
		}
	}

	mjx-container {
		font-family: "Times New Roman", Times, serif;
	}

	.isLoading {
		background-color: #619DFF !important;
	}

	.chat-container {
		position: fixed;
		z-index: 1033;
		width: 704px;
		right: 0;
		top: 0;
		height: 100vh;
		background-color: #FFFFFF;
		box-shadow: 0px 1px 7px 1px rgba(13, 104, 255, 0.35);
		transition: transform 0.3s ease-in-out;

		// background-color: #f5f7fa;
		.header-action {
			position: absolute;
			right: 4%;
			display: flex;
			justify-content: flex-end;
			padding-top: 2.5vh;
			margin-bottom: 1vh;
			width: 96%;
			background: #fff;

			>div {
				width: 1.49vh;
				height: 1.49vh;
				background-position: center;
				background-size: cover;
				background-repeat: no-repeat;
				cursor: pointer;
			}

			.fullscreen {
				background-image: url('@/assets/images/ai/fullscreen.png');
				margin-right: 1vw;
			}

			.close {
				background-image: url('@/assets/images/ai/close.png');
			}
		}

		.overflow-container {
			height: calc(100vh - 150px);
			padding-top: 1.4vh;
			overflow-y: auto;
			padding: 0 4%;

			.hello {
				padding: 1.49vh 0;
				display: flex;
				align-items: center;
				margin-top: 30px;

				.left {
					padding: 0 0 .8vh 0;

					.hello-text {
						background-image: url("@/assets/images/ai/hello-text.png");
						min-height: 2.3vh;
						min-width: 25vh;
						background-position: center;
						background-size: cover;
						background-repeat: no-repeat;
					}

					.text {
						font-weight: normal;
						font-size: 12px;
						color: #333333;
						line-height: 14px;
						margin-top: 1.67vh;
					}
				}
			}

			.hot-container {
				background: rgba(1, 94, 230, 0.1);
				border-radius: 24px;
				margin: 2.79vh 0;
				font-size: 14px;
				color: #666666;
				line-height: 22px;
				padding: 20px;

				.title {
					font-size: 16px;
					color: #333333;
					line-height: 14px;
					font-weight: 600;
				}

				.labels {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;
					cursor: pointer;

					.label {
						width: 49%;
						background: #FFFFFF;
						border-radius: 8px;
						margin-top: 16px;
						padding: 8px 16px;
						box-sizing: border-box;
						display: flex;
						align-items: center;
						font-size: 12px;
						font-weight: bold;

						.star {
							background-image: url('@/assets/images/ai/star.png');
							background-position: center;
							background-size: cover;
							background-repeat: no-repeat;
							width: 12px;
							height: 12px;
							margin-right: 6px;
						}
					}

					.label:hover,
					.labelCheck {
						border: 1px solid #015EE6;
						color: #015EE6;
						padding: 6px 16px;

						.star {
							background: url('@/assets/images/ai/star-active.png');
							background-position: center;
							background-size: cover;
							background-repeat: no-repeat;
							width: 12px;
							height: 12px;
							margin-right: 6px;
						}
					}
				}
			}

			.recommend-container {
				width: calc(100%-100px);
				margin-left: 50px;
				margin-bottom: 20px;

				.label {
					width: 50%;
					background: #FFFFFF;
					border-radius: 8px;
					margin-top: 16px;
					padding: 8px 16px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					font-size: 12px;
					border: 1px solid #999999;
					color: #333333;
					display: flex;
					justify-content: space-between;

					.next {
						background-image: url('@/assets/images/ai/next.png');
						background-position: center;
						background-size: cover;
						background-repeat: no-repeat;
						width: 12px;
						height: 12px;
						margin-right: 6px;
					}
				}

				.label:hover,
				.labelCheck {
					background: #E5EFFC;
					border: 1px solid #0D68FF;

					.next {
						background-image: url('@/assets/images/ai/next-active.png');
					}
				}

			}
		}
	}

	.initChat {
		/*right: calc(-51vw);*/
		transform: translateX(110%);
		transition: transform 0.3s;
	}

	.fullscreen {
		width: 100%;
	}

	@keyframes elasticScale {
		0% {
			transform: scale(1);
			/* 初始状态 */
		}

		50% {
			transform: scale(1.2);
			/* 中间状态：放大到 1.3 倍 */
		}

		100% {
			transform: scale(1);
			/* 最终状态：放大到 1.1 倍 */
		}
	}

	@keyframes jumpOut {
		0% {
			transform: translateX(100%) scale(0);
			/* 初始状态：从下方进入，缩小 */
			opacity: 0;
			/* 初始透明度为 0 */
			box-shadow: 0 0 0 rgba(0, 0, 0, 0);
			/* 无阴影 */
		}

		50% {
			transform: translateX(-10px) scale(1.2);
			/* 中间状态：向上跳起，稍微放大 */
			opacity: 1;
			/* 完全可见 */
			box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
			/* 添加阴影 */
		}

		100% {
			transform: translateY(0) scale(1);
			/* 最终状态：回到原位，恢复正常大小 */
			box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
			/* 阴影减弱 */
		}
	}

	.chat-main {
		flex: 1;
		// margin-left: 15px;
		// margin-right: 15px;
		// border-radius: 12px;
		// background: #F5F7F9;
		// box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		padding: 0;

		.chat-container-wrapper {
			display: flex;
			flex-direction: column;
			height: 100%;
		}
	}

	.chat-messages {
		flex: 1;
		// overflow-y: auto;
		background-color: #fff;

		.message {
			display: flex;
			margin-bottom: 20px;

			&-user {
				flex-direction: row-reverse;

				.message-content {
					margin-right: 12px;
					max-width: 100%;

					img {
						max-width: 100%;
						max-height: 100px;
					}

					.message-text {
						color: #fff;
						background: rgba(13, 104, 255, 0.65);
						border-radius: 10px 0px 10px 10px;
					}
				}
			}

			&-ai .message-content {
				margin-left: 12px;
				max-width: calc(100% - 52px);

				.message-text {
					background: #fff;
					border-radius: 2px 12px 12px 12px;
					padding: 0;
				}

				.think {
					background: rgba(13, 104, 255, 0.1);
					color: #0D68FF;
					padding: 12px 16px;
				}
			}

			&-avatar {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			&-ai .message-avatar {
				width: 40px;
				height: 47px;
				margin-top: -7px;
				border-radius: 0;
			}

			&-content {
				max-width: 70%;
			}

			&-text {
				padding: 12px 16px;
				font-size: 14px;
				line-height: 1.5;
			}

			&-time {
				margin-bottom: 4px;
				font-size: 12px;
				color: #999;
			}
		}
	}

	.chat-input-wrapper {
		flex-shrink: 0;
		background: #fff;
		width: 92%;
		left: 4%;
		position: absolute;
		bottom: 20px;
		height: 100px;

		.chat-input {
			.input-wrapper {
				display: flex;
				gap: 10px;

				.el-input {
					flex: 1;
					// ::v-deep textarea{
					//   height: 180px;
					// }
				}

				::v-deep .el-textarea__inner:focus {
					background: rgba(255, 255, 255, 0.1);
					box-shadow: 0px 2px 13px 1px rgba(1, 94, 230, 0.35);
					border: 1px solid #0D68FF;
				}

				::v-deep .el-textarea__inner:focus+.send-message {
					background-color: #015EE6;

				}

				::v-deep .el-textarea__inner {
					border-radius: 18px;
				}

				.el-button {
					align-self: flex-end;
				}

				.send-btn {
					position: absolute;
					bottom: 10px;
					right: 10px;

					>div {
						position: absolute;
					}

					.send-upload {
						background-image: url("@/assets/images/ai/upload.png");
						background-position: center;
						background-size: cover;
						background-repeat: no-repeat;
						right: 45px;
						width: 15px;
						height: 15px;
						bottom: 8px;
					}

					.send-message {
						right: 10px;
						bottom: 5px;
						background-color: rgba(1, 94, 230, 0.15);
						border-radius: 50%;
						width: 15px;
						height: 15px;
						padding: 4px;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;

						.message-icon {
							// background-image: url("@/assets/images/ai/send.png");
							width: 12px;
							height: 12px;
							position: relative;
							// top: 2px;
							// left: 1px;
							// left: 3px;
							// background-position: center;
							// background-size: cover;
							// background-repeat: no-repeat;
							color: #fff;
						}
					}

					.send-message-active {
						background-color: #015EE6;

					}
				}
			}
		}
	}
</style>
<style lang="scss">
	.custom-tooltip {
		box-shadow: 0px 0px 8px 0px rgba(13, 104, 255, 0.65) !important;
		border: 1px solid #E8E8E8 !important;

		&[x-placement^="top"] .popper__arrow {
			border-top-color: #fff !important;

			&::after {
				border-top-color: #fff !important;
			}
		}

		&[x-placement^="right"] .popper__arrow {
			border-right-color: #fff !important;

			&::after {
				border-right-color: #fff !important;
			}
		}

		&[x-placement^="bottom"] .popper__arrow {
			border-bottom-color: #fff !important;

			&::after {
				border-bottom-color: #fff !important;
			}
		}

		&[x-placement^="left"] .popper__arrow {
			border-left-color: #fff !important;

			&::after {
				border-left-color: #fff !important;
			}
		}
	}
</style>